import { Mail, Phone, MapPin, Instagram, Facebook, Anchor } from "lucide-react";
import { Link } from "react-router-dom";
import { IMAGES } from "../lib/data";

const ITEMS = [
  { icon: Mail, label: "Email", value: "anchormgtbda@gmail.com", href: "mailto:anchormgtbda@gmail.com", testid: "contact-email" },
  { icon: Phone, label: "Phone", value: "441-519-1794", href: "tel:+14415191794", testid: "contact-phone" },
  { icon: MapPin, label: "Location", value: "Bermuda", href: null, testid: "contact-location" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-sand">
      <section className="pt-28 pb-16 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="overline mb-5">Contact</div>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl lg:text-7xl text-navy leading-[1.02] max-w-4xl">
          Say hello.
        </h1>
        <p className="mt-6 text-[color:var(--am-muted)] max-w-xl leading-relaxed">
          Questions about dates, menus, or a specific kind of day you have in
          mind? We answer every message personally.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6 img-zoom aspect-[4/5] overflow-hidden">
          <img src={IMAGES.deck} alt="Bavaria 35 galley aboard Anchor Management" className="w-full h-full object-cover" />
        </div>

        <div className="lg:col-span-6 flex flex-col justify-center">
          <div className="space-y-8">
            {ITEMS.map((item, i) => (
              <div key={i} className="border-b border-[color:var(--am-line)] pb-6 flex items-start gap-5" data-testid={item.testid}>
                <item.icon size={20} strokeWidth={1.4} className="text-navy mt-1" />
                <div>
                  <div className="overline mb-2">{item.label}</div>
                  {item.href ? (
                    <a href={item.href} className="font-serif-display text-2xl md:text-3xl text-navy hover:underline">
                      {item.value}
                    </a>
                  ) : (
                    <div className="font-serif-display text-2xl md:text-3xl text-navy">{item.value}</div>
                  )}
                </div>
              </div>
            ))}

            <div className="pt-2">
              <div className="overline mb-4">Follow Along</div>
              <div className="flex items-center gap-4">
                <a
                  href="https://www.instagram.com/anchormgtbda/"
                  target="_blank"
                  rel="noreferrer"
                  className="w-12 h-12 border border-navy flex items-center justify-center text-navy hover:bg-navy hover:text-white transition-colors"
                  aria-label="Instagram @anchormgtbda"
                  data-testid="contact-instagram"
                >
                  <Instagram size={18} strokeWidth={1.5} />
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noreferrer"
                  className="w-12 h-12 border border-navy flex items-center justify-center text-navy hover:bg-navy hover:text-white transition-colors"
                  aria-label="Facebook"
                  data-testid="contact-facebook"
                >
                  <Facebook size={18} strokeWidth={1.5} />
                </a>
                <a
                  href="https://www.instagram.com/anchormgtbda/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-navy/80 hover:text-navy tracking-[0.12em] uppercase"
                  data-testid="contact-instagram-handle"
                >
                  @anchormgtbda
                </a>
              </div>
            </div>

            <div className="pt-6">
              <Link to="/book" className="btn-primary" data-testid="contact-book-button">
                <Anchor size={14} /> Book a Charter
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
